import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, MapPinIcon } from 'lucide-react';
import type { ChoirEvent, Rsvp } from '../../types';
import { Badge } from '../ui/Badge';
import { eventTitle, eventTypeClass, eventTypeShort, formatDate, formatRange, weekdayShort, parseDate } from '../../utils/labels';
interface EventCardProps {
  event: ChoirEvent;
  rsvp?: Rsvp;
  to: string;
  expected?: boolean;
}
export function EventCard({
  event,
  rsvp,
  to,
  expected = true
}: EventCardProps) {
  const d = parseDate(event.datum);
  return <Link to={to} className="flex items-center gap-4 rounded-xl border border-line bg-white p-3.5 shadow-card transition-colors duration-150 ease-out hover:border-green-200 hover:bg-green-50/30" data-id="element-251" data-mp="1xeg6zga5d890">
      <div className="flex h-14 w-14 shrink-0 flex-col items-center justify-center rounded-lg bg-canvas" data-id="element-252" data-mp="74cyohpuwnqd">
        <span className="text-[11px] uppercase tracking-wide text-ink-muted" data-id="element-253" data-mp="c37qua9pron5">
          {weekdayShort(event.datum)}
        </span>
        <span className="text-lg font-semibold leading-5 text-ink" data-id="element-254" data-mp="2spxo8hul3r4">{d.getDate()}.</span>
        <span className="text-[10px] text-ink-muted" data-id="element-255" data-mp="3tyrgj38211nb">{d.getMonth() + 1}. mes.</span>
      </div>

      <div className="min-w-0 flex-1" data-id="element-256" data-mp="bsmuixee58x9">
        <div className="flex flex-wrap items-center gap-1.5" data-id="element-257" data-mp="bto570rhvteg">
          <Badge className={eventTypeClass[event.type]} data-id="element-258" data-mp="6t0ekg76hekr">{eventTypeShort[event.type]}</Badge>
          {event.potovanje?.aktivno && <Badge className="bg-purple-50 text-purple-700 border-purple-200" data-id="element-259" data-mp="lopvhzxib1im">Gostovanje</Badge>}
          {event.opomba && <Badge className="bg-canvas text-ink-muted border-line" data-id="element-260" data-mp="gpmxv0juvxko">{event.opomba}</Badge>}
          {!event.steje && <Badge className="bg-slate-100 text-ink-muted border-line" data-id="element-261" data-mp="qhiwccputppf">Ne šteje</Badge>}
        </div>
        <p className="mt-1.5 truncate text-sm font-semibold text-ink" data-id="element-262" data-mp="14g8wk17z05i0">{eventTitle(event)}</p>
        <p className="mt-0.5 flex items-center gap-1 truncate text-[13px] text-ink-muted" data-id="element-263" data-mp="zih4963eyhda">
          {event.datumDo ? formatRange(event.datum, event.datumDo) : `${formatDate(event.datum)} · ${event.zacetek}${event.konec ? `–${event.konec}` : ''}`}
          <span className="mx-1 text-line" data-id="element-264" data-mp="13s66es8lym2">|</span>
          <MapPinIcon className="h-3.5 w-3.5 shrink-0" data-id="element-265" data-mp="64fs4m1lzp9f" />
          <span className="truncate" data-id="element-266" data-mp="avxwlk2uc7z5">{event.lokacija}</span>
        </p>
      </div>

      <div className="flex shrink-0 items-center gap-2" data-id="element-267" data-mp="axsgqw6afw26">
        {!expected ? <Badge className="bg-slate-100 text-ink-muted border-line" data-id="element-268" data-mp="furavepyc30d">Ni obvezno</Badge> : rsvp?.status === 'pridem' ? <Badge className="bg-green-50 text-green-700 border-green-200" dot="bg-green-500" data-id="element-269" data-mp="ovpcjqcx3yfs">
            Pridem
          </Badge> : rsvp?.status === 'ne_morem' ? <Badge className="bg-rose-50 text-rose-700 border-rose-200" dot="bg-rose-500" data-id="element-270" data-mp="tspky7x8pda2">
            Odsoten/a
          </Badge> : <Badge className="bg-amber-50 text-amber-800 border-amber-200" data-id="element-271" data-mp="2vln8bo88zdnm">Brez odgovora</Badge>}
        <ChevronRightIcon className="hidden h-4 w-4 text-ink-muted sm:block" data-id="element-272" data-mp="2o35qmuq7wsjk" />
      </div>
    </Link>;
}